import { OWObject } from "../../../../../../OW.Remoting/Remoting/DataTypes/OWObject";
import { IFrame } from "../../IFrame";
import { XGAction } from "../XGAction";
import { IActionExecutionContext } from "./IActionExecutionContext";

export class ActionMasterExecutionContext implements IActionExecutionContext {
    private _action: XGAction;

    constructor(action: XGAction) {
        this._action = action;
    }

    public get actualObject(): OWObject | null {
        if (!this._action.owner) {
            return null;
        }
        return this._action.owner.masterObject || this._action.owner.isMainFrame && this._action.owner.ownerForm?.masterObject || null;
    }

    public get ownerFrame(): IFrame | null {
        return this._action.owner?.masterFrame;
    }
}
